import 'react';
import '../../../../_virtual/_tslib.js';
import '@apollo/client/react/components';
import { useQuery } from '@apollo/client';

var ProductQuizBusinessLeadDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "ProductQuizBusinessLead"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "leadId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "LeadId"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "lead"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "leadId"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "consumer"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "firstName"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }]
};
/**
 * __useProductQuizBusinessLeadQuery__
 *
 * To run a query within a React component, call `useProductQuizBusinessLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuizBusinessLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuizBusinessLeadQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */

function useProductQuizBusinessLeadQuery(baseOptions) {
  return useQuery(ProductQuizBusinessLeadDocument, baseOptions);
}

export { ProductQuizBusinessLeadDocument, useProductQuizBusinessLeadQuery };
//# sourceMappingURL=ProductQuizBusinessLead.generated.js.map
